import { writable, readable } from 'svelte/store'

export const baseUrl = readable()

export const showSidebar = writable(false)
export const showTopnavMenu = writable(false)
export const isAuthenticated = writable(false)
